import { FC } from 'react';
import { NEW_APPOINTMENT_ID, AppointmentsState } from './AppointmentsState';
import { PaywallAwareButton } from '../components/PaywallAwareButton';
import { DuoCalendarPlusIcon } from '../theme/Icons';
import { useBreakpoints } from '../theme/useBreakpoints';
import { useInstance } from '@meraki-internal/react-dependency-injection';

export type IAddAppointmentButtonProps = {
    canAdd: boolean;
    onClick: (apptId: string) => void;
    useIcon?: boolean;
    iconOnly?: boolean;
};

export const AddAppointmentButton: FC<IAddAppointmentButtonProps> = ({ canAdd, onClick, useIcon, iconOnly = false }) => {
    const {isBelowBreakpoint} = useBreakpoints();

    const appointmentsState = useInstance(AppointmentsState);

    const label = isBelowBreakpoint('sm') ? 'Add Appt' : 'Add Appointment';

    return canAdd && (
        <PaywallAwareButton
            fill="clear"
            color="primary"
            triggerSource="add appointment"
            data-id="add-appointment-button"
            requiresInnerhivePlus={appointmentsState.addAppointmentRequiresInnerhivePlus}
            onClick={() => onClick(NEW_APPOINTMENT_ID)}
        >
            {useIcon ? <DuoCalendarPlusIcon />: '+'}
            {!iconOnly && (
                <>&nbsp;{label}</>
            )}
        </PaywallAwareButton>
    );
};
